import Cookies from 'universal-cookie';

import { CookieBasedStorage } from '../localStorage';
import { ICookieOptionsProvider } from './CookieOptionsProvider';
import IPreferredStoreProvider from './IPreferredStoreProvider';

export default class CookiePreferredCountryProvider implements IPreferredStoreProvider {
  private preferredCountryKey = 'flokk-preferred-country';
  private storage: CookieBasedStorage;

  constructor(cookies: Cookies, private cookieOptionsProvider: ICookieOptionsProvider) {
    this.storage = new CookieBasedStorage(cookies, 365 * 86400, this.cookieOptionsProvider);
  }

  getStoreId(): string {
    return null;
  }

  getCountryCode(): string {
    return this.storage.get(this.preferredCountryKey);
  }

  getLanguageCode(): string {
    return null;
  }

  setStoreId(id: string): void {
    return;
  }

  setCountryCode(code: string): void {
    this.storage.set<string>(this.preferredCountryKey, code);
  }

  setLanguageCode(code: string): void {
    return;
  }
}
